<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent();"
  [title]="titlePage" start="{{startStage}}" end="{{endStage}}"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
  
  <div #contentScroll class="content-scroll" [ngClass]="{'content-scroll--button': verifyStatusBtn()}">
    <app-ion-common-label labelStyle="display-rg text-dark" labelDescription="Falta pouco para você investir"
      label="Para finalizar, você precisa declarar que leu e aceitou os termos.">
    </app-ion-common-label>
  
    <div class="conent-center conent-center--ph-0">
      
      <div class="ph-block">
        <app-ion-list-buttons [id]="'list-button-term'" [data]="listTerms" (emitClick)="getTerm($event)"></app-ion-list-buttons>
      </div>
    
      <form ngForm (ngSubmit)="submitForm($event)" class="ph-block mrt-sm">
        <app-ion-common-checkbox [itens]="checkboxList" (changeCheckbox)="setSelectCheckbox($event)">
        </app-ion-common-checkbox>
      </form>
    
      <div class="additional-information mb-4">
        <p class="ph-block">Ao continuar, você também declara que não opera por conta de terceiros ou atua na administração e/ou gestão de
          fundo de investimento,
          clube de investimento ou carteira de valores mobiliários.
        </p>
      </div>
    </div>
  </div>

  <app-ion-common-button class="hidden"
    [ngClass]="{'hidden': !verifyStatusBtn()}"
    [loading_verify]="loadingVerify"
    [attr.aria-hidden]="!verifyStatusBtn()"
    [approved_verify]="approved"
    [label]="labelButton"
    [ariaLive]="false"
    (clickButton)="clickNext();">
  </app-ion-common-button>

</ion-content>

<app-loading-circle *ngIf="loading"></app-loading-circle>
<div class="sr-only" *ngIf="voicePagePost" aria-live="assertive">{{labelButton}}</div>
